<div class="shadow rounded px-3 bg-white">
    <slot/>
</div>